import { useEffect, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import { Link, useSearchParams } from "react-router-dom";
import { CircularProgress } from "@mui/material";

import SuiBox from "components/SuiBox";
import SuiTypography from "components/SuiTypography";
import SuiButton from "components/SuiButton";
import CoverLayout from "layouts/authentication/components/CoverLayout";
import curved9 from "assets/images/haazri-logo.jpg";
import { slackSignIn, SLACK_STATE_KEY } from "../auth.thunk";

// Slack sends the admin back here with `?code=…&state=…`. On success the auth
// reducer marks them signed in and PublicRoute moves them on to the dashboard.
function SlackCallback() {
  const dispatch = useDispatch();
  const [params] = useSearchParams();
  const [error, setError] = useState(null);
  // The code is single-use, so make sure it is only ever submitted once.
  const submitted = useRef(false);

  useEffect(() => {
    if (submitted.current) return;
    submitted.current = true;

    const code = params.get("code");
    const state = params.get("state");
    const expectedState = sessionStorage.getItem(SLACK_STATE_KEY);
    sessionStorage.removeItem(SLACK_STATE_KEY);

    if (params.get("error")) {
      setError("Slack sign-in was cancelled.");
    } else if (!code || !state || state !== expectedState) {
      setError("Sign-in expired. Please try again.");
    } else {
      dispatch(slackSignIn({ code, state }))
        .unwrap()
        .catch((err) => setError(err.message));
    }
  }, []);

  return (
    <CoverLayout
      title="Haazri Admin Portal"
      description={error ? "We couldn't sign you in" : "Signing you in with Slack…"}
      image={curved9}
    >
      {error ? (
        <>
          <SuiTypography variant="body2" color="error" fontWeight="regular">
            {error}
          </SuiTypography>
          <SuiBox mt={4} mb={1}>
            <SuiButton
              component={Link}
              to="/authentication/sign-in"
              variant="gradient"
              color="info"
              fullWidth
            >
              back to sign in
            </SuiButton>
          </SuiBox>
        </>
      ) : (
        <SuiBox display="flex" justifyContent="center" mt={2}>
          <CircularProgress color="info" size={32} />
        </SuiBox>
      )}
    </CoverLayout>
  );
}

export default SlackCallback;
